export const handwriting = 'Kalam, cursive';
export const standard = 'Calibre, sans-serif';
export const lightFontWeight = '300';
export const regularFontWeight = '400';
export const mediumFontWeight = '500';
export const boldFontWeight = '700';
